export default __webpack_public_path__ + "static/trash._jpg_-1e83685df59dd600158d3931b4628ce5.jpg";